import { render, staticRenderFns } from "./CbsDashboard.vue?vue&type=template&id=2ac72f9e&scoped=true"
import script from "./CbsDashboard.vue?vue&type=script&lang=js"
export * from "./CbsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac72f9e",
  null
  
)

export default component.exports